import * as React from 'react';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import {
  Button,
  DateTextBox, FlexLayout, GridLayout, LayoutTitle, ModalView, SearchLayout, SubHeader, TabLayout,
} from '../../../../components';
import { Global, TemplateProps } from '../../../../constants';
import { ConstructionSalesTab } from './ConstructionSales.tab';
import { GridHeader } from './headers/GridHeader';
import { ConstructionSales } from './ConstructionSales';
import { Date8 } from '../../../../utils/time';
import { Format } from '../../../../utils/string';

/**
 * 화면
 * @window w_tb_e471w_04
 * @category 공사수주매출통계
 */
export const ConstructionSalesTemplate: React.FC<TemplateProps<ConstructionSales>> = ({
  scope,
}) => (
  <FlexLayout isVertical={true}>
    <SearchLayout size={Global.LAYOUT_SEARCH_HEIGHT_1}>
      <FlexLayout size={200}>
        <span>년도</span>
        <DateTextBox
          value={scope.state.year}
          textAlign="center"
          format="####"
          onChange={(value) => scope.setState({ year: value })}
          onEnter={(value) => scope.setState({ year: value }, () => scope.onRetrieveEvent())}
          head={(
            <button
              onClick={() => {
                const date = new Date(`${scope.state.year}-01-01`);
                date.setFullYear(date.getFullYear() - 1);
                scope.setState({ year: date.getFullYear().toString() },
                  () => scope.onRetrieveEvent());
              }}
            >
              <MdKeyboardArrowLeft size={24}/>
            </button>
          )}
          trail={(
            <button
              onClick={() => {
                const date = new Date(`${scope.state.year}-01-01`);
                date.setFullYear(date.getFullYear() + 1);
                scope.setState({ year: date.getFullYear().toString() },
                  () => scope.onRetrieveEvent());
              }}
            >
              <MdKeyboardArrowRight size={24}/>
            </button>
          )}
          isDisabledTrackingStateChange={true}
        elField="year"
        />
      </FlexLayout>
    </SearchLayout>

    <FlexLayout isVertical={true}>
      <FlexLayout>
        <GridLayout
          header={GridHeader(scope)}
          rowHeight={Global.LAYOUT_GRID_HEIGHT_1}
          data={scope.state.data}
          infinityHandler={scope.infinity}
          onRowClick={(row, index) => scope.onRowFocusEvent(row, index)}
          onRowDoubleClick={() => scope.textModal(true, '1')}
        elGrid="data"
        />
      </FlexLayout>

      <FlexLayout>
        <TabLayout
          scope={scope}
          tabs={ConstructionSalesTab}
          onChange={(item, index) => scope.onTabChange(item, index)}
        />
      </FlexLayout>
    </FlexLayout>

    <ModalView
      width={1200}
      height={600}
      isVisible={scope.state.textDetailModal}
      onClose={() => scope.textModal(false, '')}
      zIndex={-2}
    >
      <FlexLayout
        isVertical={true}
        style={{ padding: 10 }}
      >
        <LayoutTitle>공사수주매출통계</LayoutTitle>

        <GridLayout
          ref={scope.grid}
          header={[
            {
              id: 'compdate',
              text: '계약일자',
              width: 100,
              render: (x) => (
                <FlexLayout
                  justify="center"
                  align="center"
                  style={{ color: 'var(--color-blue)' }}
                >
                  {Date8.withDash(x.compdate)}
                </FlexLayout>
              ),
            },
            {
              id: 'actcd',
              text: '코드',
              width: 70,
              render: (x) => (
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {x.actcd}
                </FlexLayout>
              ),
            },
            {
              id: 'actnm',
              text: '현장명',
              width: 200,
              trail: () => (
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  합계
                </FlexLayout>
              ),
              render: (x) => (
                <FlexLayout
                  justify="left"
                  align="center"
                >
                  {x.actnm}
                </FlexLayout>
              ),
            },
            {
              id: 'projno',
              text: '프로젝트번호',
              width: 100,
              render: (x) => (
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {x.projno}
                </FlexLayout>
              ),
            },
            {
              id: 'contamt',
              text: '수주금액',
              width: 100,
              trail: () => (
                <FlexLayout
                  justify="right"
                  align="center"
                  style={{ color: '#7F7A2C' }}
                >
                  {Format.number(scope.state.modal_contamt_tot)}
                </FlexLayout>
              ),
              render: (x) => (
                <FlexLayout
                  justify="right"
                  align="center"
                  style={{ color: '#7F7A2C' }}
                >
                  {Format.number(x.contamt)}
                </FlexLayout>
              ),
            },
            {
              id: 'contamt12',
              text: '수주(수리)',
              width: 100,
              trail: () => (
                <FlexLayout
                  justify="right"
                  align="center"
                  style={{ color: '#7F7A2C' }}
                >
                  {Format.number(scope.state.modal_contamt12_tot)}
                </FlexLayout>
              ),
              render: (x) => (
                <FlexLayout
                  justify="right"
                  align="center"
                  style={{ color: '#7F7A2C' }}
                >
                  {Format.number(x.contamt12)}
                </FlexLayout>
              ),
            },
            {
              id: 'contamt13',
              text: '수주(부품)',
              width: 100,
              trail: () => (
                <FlexLayout
                  justify="right"
                  align="center"
                  style={{ color: '#7F7A2C' }}
                >
                  {Format.number(scope.state.modal_contamt13_tot)}
                </FlexLayout>
              ),
              render: (x) => (
                <FlexLayout
                  justify="right"
                  align="center"
                  style={{ color: '#7F7A2C' }}
                >
                  {Format.number(x.contamt13)}
                </FlexLayout>
              ),
            },
            {
              id: 'contamtmu',
              text: '수주(무상)',
              width: 100,
              trail: () => (
                <FlexLayout
                  justify="right"
                  align="center"
                  style={{ color: '#633A00' }}
                >
                  {Format.number(scope.state.modal_contamtmu_tot)}
                </FlexLayout>
              ),
              render: (x) => (
                <FlexLayout
                  justify="right"
                  align="center"
                  style={{ color: '#633A00' }}
                >
                  {Format.number(x.contamtmu)}
                </FlexLayout>
              ),
            },
            {
              id: 'notmisamt',
              text: '미매출',
              width: 100,
              trail: () => (
                <FlexLayout
                  justify="right"
                  align="center"
                  style={{ color: 'var(--color-red)' }}
                >
                  {Format.number(scope.state.modal_notmisamt_tot)}
                </FlexLayout>
              ),
              render: (x) => (
                <FlexLayout
                  justify="right"
                  align="center"
                  style={{ color: 'var(--color-red)' }}
                >
                  {Format.number(x.notmisamt)}
                </FlexLayout>
              ),
            },
            {
              id: 'misamt',
              text: '공사매출',
              width: 100,
              trail: () => (
                <FlexLayout
                  justify="right"
                  align="center"
                >
                  {Format.number(scope.state.modal_misamt_tot)}
                </FlexLayout>
              ),
              render: (x) => (
                <FlexLayout
                  justify="right"
                  align="center"
                >
                  {Format.number(x.misamt)}
                </FlexLayout>
              ),
            },
            {
              id: 'rcvamt',
              text: '공사입금',
              width: 100,
              trail: () => (
                <FlexLayout
                  justify="right"
                  align="center"
                  style={{ color: 'var(--color-blue)' }}
                >
                  {Format.number(scope.state.modal_rcvamt_tot)}
                </FlexLayout>
              ),
              render: (x) => (
                <FlexLayout
                  justify="right"
                  align="center"
                  style={{ color: 'var(--color-blue)' }}
                >
                  {Format.number(x.rcvamt)}
                </FlexLayout>
              ),
            },
            {
              id: 'iamt',
              text: '공사미수금',
              width: 100,
              trail: () => (
                <FlexLayout
                  justify="right"
                  align="center"
                  style={{ color: 'var(--color-red)' }}
                >
                  {Format.number(scope.state.modal_iamt_tot)}
                </FlexLayout>
              ),
              render: (x) => (
                <FlexLayout
                  justify="right"
                  align="center"
                  style={{ color: 'var(--color-red)' }}
                >
                  {Format.number(x.iamt)}
                </FlexLayout>
              ),
            },
            {
              id: 'jamt',
              text: (
                <FlexLayout
                  align="start"
                  justify="center"
                  isVertical={true}
                >
                  <FlexLayout>
                    잔액
                  </FlexLayout>

                  <FlexLayout>
                    (수주-입금)
                  </FlexLayout>
                </FlexLayout>
              ),
              width: 100,
              trail: () => (
                <FlexLayout
                  justify="right"
                  align="center"
                >
                  {Format.number(scope.state.modal_jamt_tot)}
                </FlexLayout>
              ),
              render: (x) => (
                <FlexLayout
                  justify="right"
                  align="center"
                >
                  {Format.number(x.jamt)}
                </FlexLayout>
              ),
            },
            {
              id: 'qty',
              text: '대수',
              width: 70,
              trail: () => (
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {Format.number(scope.state.modal_qty_tot)}
                </FlexLayout>
              ),
              render: (x) => (
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {x.qty}
                </FlexLayout>
              ),
            },
            {
              id: 'qty12',
              text: (
                <FlexLayout
                  align="center"
                  justify="center"
                  isVertical={true}
                >
                  <FlexLayout>
                    건수
                  </FlexLayout>

                  <FlexLayout>
                    (수리)
                  </FlexLayout>
                </FlexLayout>
              ),
              width: 70,
              trail: () => (
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {Format.number(scope.state.modal_qty12_tot)}
                </FlexLayout>
              ),
              render: (x) => (
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {x.qty12}
                </FlexLayout>
              ),
            },
            {
              id: 'qty13',
              text: (
                <FlexLayout
                  align="center"
                  justify="center"
                  isVertical={true}
                >
                  <FlexLayout>
                    건수
                  </FlexLayout>

                  <FlexLayout>
                    (부품)
                  </FlexLayout>
                </FlexLayout>
              ),
              width: 70,
              trail: () => (
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {Format.number(scope.state.modal_qty13_tot)}
                </FlexLayout>
              ),
              render: (x) => (
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {x.qty13}
                </FlexLayout>
              ),
            },
            {
              id: 'qtymu',
              text: (
                <FlexLayout
                  align="center"
                  justify="center"
                  isVertical={true}
                >
                  <FlexLayout>
                    건수
                  </FlexLayout>

                  <FlexLayout>
                    (무상)
                  </FlexLayout>
                </FlexLayout>
              ),
              width: 70,
              trail: () => (
                <FlexLayout
                  justify="center"
                  align="center"
                  style={{ color: '#633A00' }}
                >
                  {Format.number(scope.state.modal_qtymu_tot)}
                </FlexLayout>
              ),
              render: (x) => (
                <FlexLayout
                  justify="center"
                  align="center"
                  style={{ color: '#633A00' }}
                >
                  {x.qtymu}
                </FlexLayout>
              ),
            },
            {
              id: 'misamt2',
              text: '매출',
              width: 100,
              trail: () => (
                <FlexLayout
                  justify="right"
                  align="center"
                >
                  {Format.number(scope.state.modal_misamt2_tot)}
                </FlexLayout>
              ),
              render: (x) => (
                <FlexLayout
                  justify="right"
                  align="center"
                >
                  {Format.number(x.misamt2)}
                </FlexLayout>
              ),
            },
            {
              id: 'rcvamt2',
              text: '입금',
              width: 100,
              trail: () => (
                <FlexLayout
                  justify="right"
                  align="center"
                  style={{ color: 'var(--color-blue)' }}
                >
                  {Format.number(scope.state.modal_rcvamt2_tot)}
                </FlexLayout>
              ),
              render: (x) => (
                <FlexLayout
                  justify="right"
                  align="center"
                  style={{ color: 'var(--color-blue)' }}
                >
                  {Format.number(x.rcvamt2)}
                </FlexLayout>
              ),
            },
            {
              id: 'iamt2',
              text: '미수금',
              width: 100,
              trail: () => (
                <FlexLayout
                  justify="right"
                  align="center"
                  style={{ color: 'var(--color-red)' }}
                >
                  {Format.number(scope.state.modal_iamt2_tot)}
                </FlexLayout>
              ),
              render: (x) => (
                <FlexLayout
                  justify="right"
                  align="center"
                  style={{ color: 'var(--color-red)' }}
                >
                  {Format.number(x.iamt2)}
                </FlexLayout>
              ),
            },
          ]}
          data={scope?.state.modalData || []}
          rowHeight={Global.LAYOUT_GRID_HEIGHT_1}
        elGrid="modalData"
        />

        <SubHeader>
          <FlexLayout justify="end">
            <Button onClick={() => scope.onModalExcel()}>EXCEL 자료</Button>
            <Button onClick={() => scope.textModal(false, '')}>닫기</Button>
          </FlexLayout>
        </SubHeader>
      </FlexLayout>
    </ModalView>
  </FlexLayout>
);
